import { render } from "./CopyTemplate.vue?vue&type=template&id=528f90d8"
import script from "./CopyTemplate.vue?vue&type=script&lang=js"
export * from "./CopyTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__